<!-- 群SOP -->
<template>
  <div>
    <div class="head-title">群SOP</div>
    <el-collapse style="margin-bottom: 2.0rem">
      <el-collapse-item title="帮助文档" name="1">
        <div class="help">
          <p>
            1、通过自建应用创建群聊营销推广内容、推广时间；员工收到应用推送后一键转发至相关群聊，后台获取发布状态。<a class="help-link"
              href="http://www.weijub.com/index/index/news_detail?id=139" target="_blank" rel="noopener noreferrer">使用教程</a>
          </p>
          <p>
            2、点击去<a class="help-link" href="https://work.weixin.qq.com/" target="_blank"
              rel="noopener noreferrer">企业微信</a>配置工具栏URL
          </p>
        </div>
      </el-collapse-item>
    </el-collapse>

    <div class="mMain">
      <nav class="navbar">
        <div class="nav-l">
          <el-button type="primary" icon="el-icon-plus" @click="onAdd">新建群SOP</el-button>
          <el-button style="margin-left: 2.4rem" class="copy-url" type="primary" icon="el-icon-copy-document"
            @click="copyUrl">复制工具栏URL</el-button>
          <el-button style="margin-left: 2.4rem" type="danger" icon="el-icon-delete" @click="onDels">批量删除</el-button>
        </div>
        <div class="nav-r">
          <div>
            <el-date-picker v-model="time" type="datetimerange" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期" @change="getList()">
            </el-date-picker>
          </div>
          <div style="margin-left: 2.4rem" @click.stop="onSelectCheckPerson">
            <el-input v-model="check.name" placeholder="请选择监督人" @change="clearD" clearable></el-input>
          </div>
          <div style="margin-left: 2.4rem">
            <el-input v-model="rule_title" style="width: 22.0rem; margin: 0 2.0rem 0 2.0rem" prefix-icon="el-icon-search"
              placeholder="请输入规则名称搜索" clearable @change="getList()">
            </el-input>
            <el-button type="primary" slot="append" @click="getList">查询</el-button>
          </div>
        <!-- <div style="margin-left: 2.4rem">
            <el-button @click="onClear">清空</el-button>
              </div> -->
        </div>
      </nav>
      <div class="main">
        <el-table :data="list" style="margin-top: 2.0rem" border @selection-change="handleSelectionChange" v-loading="tableLoading"
          >
          <el-table-column type="selection" width="40"> </el-table-column>
          <el-table-column prop="rule_title" label="规则名称" style="width:11.11%" show-overflow-tooltip="">
          </el-table-column>
          <el-table-column prop="check_userid_name" label="监督人" style="width:11.11%" show-overflow-tooltip="">
          </el-table-column>
          <el-table-column prop="check_time" label="监督人推送时间" style="width:11.11%">
            <template slot-scope="scope">
              <div>
                {{ (scope.row.check_time * 1000) | formatDate }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="群聊" style="width:11.11%">
            <template slot-scope="scope">
              <div>
                <el-tag size="mini" style="margin: .2rem" v-for="(i, index) in scope.row.chat_user_arrays" :key="index">{{
                  i.chat_names }}</el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="remind_time" label="群主推送时间" style="width:11.11%">
            <template slot-scope="scope">
              <div>
                {{ (scope.row.remind_time * 1000) | formatDate }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="title" label="内容标题" style="width:11.11%" show-overflow-tooltip="">
          </el-table-column>
          <el-table-column label="推送内容" show-overflow-tooltip="" style="width:11.11%">
            <template slot-scope="scope">
              <div v-if="scope.row.type == '文本'">
                {{ scope.row.content }}
              </div>
              <div v-if="scope.row.type == '图片'">
                <el-image style="width: 7.0rem; height: 7.0rem" :src="scope.row.url" :preview-src-list="[scope.row.url]"
                  fit="scale-down"></el-image>
              </div>
              <div v-if="scope.row.type == '视频'">
                <video style="width: 20.0rem; height: 11.2rem" :src="scope.row.url" controls="controls"></video>
              </div>
              <div v-if="scope.row.type == '文件'">
                <el-link type="primary" :href="scope.row.url" target="_blank">{{
                  scope.row.url
                }}</el-link>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="SOP状态" style="width:11.11%">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.status" :active-value="1" :inactive-value="2"
                @change="toggleStatus(scope.row)"></el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作"  fixed="right" width="300" >
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="onEdit(scope.row)">
                编辑
              </el-button>
              <el-button type="text" size="mini" @click="onPreview(scope.row)">完成情况</el-button>
              <el-button @click="onDel(scope.row)" size="mini" type="text" style="color:#f00000 !important">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="paging">
          <pagination :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit"
            :page-sizes="[10, 20, 50, 100]" @pagination="getList" />
        </div>
      </div>
    </div>
    <el-dialog title="已完成情况" center :visible.sync="dialogVisible" width="60%">
      <nav class="navbar">
        <div class="nav-l">
          <div @click="addGroupChatOwner">
            <el-input v-model="chatOwner.owner_name" placeholder="请选择群主"></el-input>
          </div>
          <div style="margin-left: 2.4rem" @click="addGroupChatId">
            <el-input v-model="chatId.name" placeholder="请选择群聊"></el-input>
          </div>
          <div style="margin-left: 2.4rem">
            <el-date-picker v-model="timeFinsh" type="datetimerange" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期" @change="getListFinsh()">
            </el-date-picker>
          </div>
        <!-- <div style="margin-left: 2.4rem">
            <el-button @click="onClearFinsh">清空</el-button>
              </div> -->
        </div>
      </nav>
      <div>
        <el-table :data="listFinsh" style="margin-top: 2.0rem" border >
          <el-table-column prop="chat_owner_name" label="群主" width="100">
          </el-table-column>
          <el-table-column label="群聊" width="270">
            <template slot-scope="scope">
              <div>
                <el-tag size="mini" style="margin: .2rem">{{
                  scope.row.chat_user_arrays.chat_names
                }}</el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="群人数">
            <template slot-scope="scope">
              <div>
                {{ scope.row.chat_user_arrays.chat_count }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="内容标题" min-width="180" show-overflow-tooltip="">
            <template slot-scope="scope">
              <div>
                {{ scope.row.send_contents.title }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="推送内容" show-overflow-tooltip="" min-width="240">
            <template slot-scope="scope">
              <div v-if="scope.row.send_contents.type == '文本'">
                {{ scope.row.send_contents.content }}
              </div>
              <div v-if="scope.row.send_contents.type == '图片'">
                <el-image style="width: 7.0rem; height: 7.0rem" :src="scope.row.send_contents.url"
                  :preview-src-list="[scope.row.send_contents.url]" fit="scale-down"></el-image>
              </div>
              <div v-if="scope.row.send_contents.type == '视频'">
                <video style="width: 20.0rem; height: 11.2rem" :src="scope.row.url" controls="controls"></video>
              </div>
              <div v-if="scope.row.send_contents.type == '文件'">
                <el-link type="primary" :href="scope.row.send_contents.url" target="_blank">{{ scope.row.send_contents.url
                }}</el-link>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="createtime" label="推送时间" width="150">
          </el-table-column>
        </el-table>
        <div class="paging">
          <pagination :total="totalFinsh" :page.sync="listQueryFinsh.page" :limit.sync="listQueryFinsh.limit"
            :page-sizes="[10, 20, 50, 100]" @pagination="getListFinsh" />
        </div>
      </div>
      <div slot="footer">
        <el-button @click="dialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
    <right-people ref="dialog" :checkbox="checkbox" @handleSelect="handleSelect"></right-people>
    <right-group ref="drawer" :checkbox="checkbox" @handleSelect="handleSelect"></right-group>
  </div>
</template>

<script>
import moment from "moment";
import rightPeople from '@/components/drawer/rightPeople';
import rightGroup from '@/components/drawer/rightGroup';
export default {
  name: "groupSop",
  components: {
    rightPeople,
    rightGroup
  },
  data() {
    return {
      total: 0,
      list: [],
      listQuery: {
        page: 1,
        limit: 20,
      },
      totalFinsh: 0,
      listFinsh: [],
      listQueryFinsh: {
        page: 1,
        limit: 20,
      },
      dialogVisible: false,
      chatOwner: {
        owner_name: "",
      },
      chatId: {
        name: "",
      },
      time: "",
      timeFinsh: "",
      id: "",
      m: "",
      rule_title: "",
      module: "",
      check: {
        name: "",
      },
      multipleSelection: "",
      checkbox: false,
      tableLoading: true
    };
  },

  computed: {},
  filters: {
    formatDate: function (value) {
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
    },
  },

  mounted() {
    this.getList();
  },

  methods: {
    onClear() {
      this.time = "";
      this.check = {
        name: "",
      };
      this.rule_title = "";
      this.getList();
    },
    onClearFinsh() {
      this.timeFinsh = "";

      this.chatOwner = {
        owner: "",
      };
      this.chatId = {
        id: "",
      };
      this.getListFinsh();
    },
    copyUrl() {
      const input = document.createElement("input");
      input.setAttribute("readonly", "readonly");
      input.setAttribute("value", `pages/groupSopPush/groupSopPush`);
      document.body.appendChild(input);
      input.select();
      if (document.execCommand("copy")) {
        document.execCommand("copy");
        this.$message.success("复制成功");
      }
      document.body.removeChild(input);
    },
    handleSelect(person) {
      switch (this.m) {
        case "check":
          this.check = person;
          this.getList();
          break;
        case "owner":
          this.chatOwner = person;
          this.getListFinsh();
          break;
        case "id":
          this.chatId = person;
          this.getListFinsh();
          break;
        default:
          break;
      }
    },
    onSelectCheckPerson() {
      this.m = "check";
      this.module = "getAddressBook";
      this.$refs.dialog.open();
    },
    addGroupChatOwner() {
      this.m = "owner";
      this.module = "getClientBaseList";
      this.$refs.drawer.open();
    },
    addGroupChatId() {
      this.m = "id";
      this.module = "getClientBaseList";
      this.$refs.drawer.open();
    },
    onPreview(row) {
      this.id = row.id;
      this.getListFinsh();
      this.dialogVisible = true;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    onAdd() {
      this.$router.push({
        name: "groupSopDetail",
      });
    },
    onEdit(row) {
      this.$router.push({
        name: "groupSopDetail",
        query: {
          id: row.id,
        },
      });
    },
    async getListFinsh() {
      let start_time = "";
      let end_time = "";
      if (Array.isArray(this.timeFinsh)) {
        start_time = new Date(this.timeFinsh[0]).getTime();
        end_time = new Date(this.timeFinsh[1]).getTime();
        start_time = start_time / 1000;
        end_time = end_time / 1000;
      } else {
        start_time = "";
        end_time = "";
      }

      const { data: res } = await this.axios({
        url: "/crm/GroupSop/accomplishCondition",
        method: "POST",
        data: this.qs.stringify({
          usertoken: this.tooken.usertoken,
          account_id: this.tooken.account_id,
          phone: this.tooken.phone,
          page: this.listQueryFinsh.page,
          number_page: this.listQueryFinsh.limit,
          id: this.id,
          chat_owner: this.chatOwner.owner,
          chat_id: this.chatId.chat_id,
          start_time,
          end_time,
        }),
      });
      if (res.code == 1) {
        this.listFinsh = res.data.data;
        this.totalFinsh = res.data.total;
      }
    },
    async getList() {
      let start_time = "";
      let end_time = "";
      if (Array.isArray(this.time)) {
        start_time = new Date(this.time[0]).getTime();
        end_time = new Date(this.time[1]).getTime();
        start_time = start_time / 1000;
        end_time = end_time / 1000;
      } else {
        start_time = "";
        end_time = "";
      }
      const { data: res } = await this.axios({
        url: "/crm/GroupSop/getList",
        method: "POST",
        data: this.qs.stringify({
          usertoken: this.tooken.usertoken,
          account_id: this.tooken.account_id,
          phone: this.tooken.phone,
          page: this.listQuery.page,
          number_page: this.listQuery.limit,
          rule_title: this.rule_title,
          check_userid: this.check.userid,
          start_time,
          end_time,
        }),
      });
      if (res.code == 1) {
        this.tableLoading = false;
        this.list = res.data.data;
        this.total = res.data.total;
      }
    },
    async toggleStatus(row) {
      const { data: res } = await this.axios({
        url: "/crm/GroupSop/openClose",
        method: "POST",
        data: this.qs.stringify({
          usertoken: this.tooken.usertoken,
          account_id: this.tooken.account_id,
          phone: this.tooken.phone,
          id: row.id,
          status: row.status,
        }),
      });
      if (res.code == 0) {
        this.$message.error(res.msg);
      }
    },
    onDels() {
      if (this.multipleSelection.length > 0) {
        this.$confirm("此操作将永久删除该条数据, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            const ids = this.multipleSelection.map((i) => i.id);
            this.del(String(ids));
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      } else {
        this.$message("请选择您要删除的数据");
      }
    },
    onDel(row) {
      this.$confirm("此操作将永久删除该条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.del(row.id);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    async del(id) {
      const { data: res } = await this.axios({
        url: "/crm/GroupSop/del",
        method: "POST",
        data: this.qs.stringify({
          usertoken: this.tooken.usertoken,
          account_id: this.tooken.account_id,
          phone: this.tooken.phone,
          id,
        }),
      });
      if (res.code == 1) {
        this.$message({
          message: "删除成功",
          type: "success",
        });
        this.getList();
      } else if (res.code == 0) {
        this.$message.error(res.msg);
      }
    },
    clearD() {
      if (this.check.name == "") {
        this.check.userid = "";
      }
      this.getList();
    },
  },
};
</script>
<style lang="scss"  scoped>
.nav-l {
  display: flex;
}

.nav-r {
  display: flex;
}
.el-button{
  height: 4.0rem;
}
</style>
